import React from 'react';
import {
  FaHome,
  FaHotel,
  FaLandmark,
  FaBuilding,
  FaUsers,
  FaChalkboardTeacher,
  FaBriefcase,
  FaArrowRight,
  FaTimes,
  FaMagic,
} from 'react-icons/fa';
import './PropertyTypeModal.css';

const publicUrl = process.env.PUBLIC_URL || '';
const HOTEL_CARD_BG = `${publicUrl}/images/hero/hero-1.jpg`;
const MEETING_CARD_BG = `${publicUrl}/conference-room-bg.jpg`;

const PropertyTypeModal = ({ isOpen, onClose, onSelectStayProperty, onSelectMeetingRoom }) => {
  if (!isOpen) return null;

  return (
    <div className="property-type-modal-overlay" onClick={onClose}>
      <div className="property-type-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-header-decor" aria-hidden="true">
            <span className="decor-sparkle decor-sparkle-1">✦</span>
            <span className="decor-sparkle decor-sparkle-2">✦</span>
            <span className="decor-sparkle decor-sparkle-3">✦</span>
            <span className="decor-dots" />
          </div>
          <div className="modal-header-main">
            <div className="modal-header-icon">
              <FaHome />
              <span className="modal-header-icon-spark">✦</span>
            </div>
            <div className="modal-header-text">
              <h2 className="modal-title">Add Property</h2>
              <p className="modal-header-subtitle">Choose what you want to add to your listing</p>
            </div>
          </div>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-body-heading">
            <h3>
              <FaMagic className="modal-body-heading-spark" aria-hidden="true" />
              What would you like to add?
              <FaMagic className="modal-body-heading-spark" aria-hidden="true" />
            </h3>
            <p>Select the type of property you want to list on our platform.</p>
          </div>

          <div className="property-cards-grid">
            <div
              className="property-card property-card-hotel"
              onClick={onSelectStayProperty}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onSelectStayProperty()}
            >
              <div
                className="property-card-bg"
                style={{ backgroundImage: `url(${HOTEL_CARD_BG})` }}
                aria-hidden="true"
              />
              <div className="property-card-inner">
                <div className="card-icon stay-icon">
                  <FaHome />
                </div>
                <h3 className="card-title">Hotel Room</h3>
                <p className="card-description">
                  Add a hotel, homestay, villa, or apartment for guests to book overnight stays.
                </p>
                <div className="card-features">
                  <span className="feature-tag"><FaHotel /> Hotels</span>
                  <span className="feature-tag"><FaHome /> Homestays</span>
                  <span className="feature-tag"><FaLandmark /> Villas</span>
                  <span className="feature-tag"><FaBuilding /> Apartments</span>
                </div>
                <button type="button" className="card-select-btn card-select-btn-hotel">
                  Add Hotel Room
                  <FaArrowRight />
                </button>
              </div>
            </div>

            <div
              className="property-card property-card-meeting"
              onClick={onSelectMeetingRoom}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onSelectMeetingRoom()}
            >
              <div
                className="property-card-bg"
                style={{ backgroundImage: `url(${MEETING_CARD_BG})` }}
                aria-hidden="true"
              />
              <div className="property-card-inner">
                <div className="card-icon meeting-icon">
                  <FaChalkboardTeacher />
                </div>
                <h3 className="card-title">Meeting Room</h3>
                <p className="card-description">
                  Add a conference room, board room, or office cabin for meetings and corporate bookings.
                </p>
                <div className="card-features">
                  <span className="feature-tag feature-tag-meeting"><FaUsers /> Conference Rooms</span>
                  <span className="feature-tag feature-tag-meeting"><FaChalkboardTeacher /> Board Rooms</span>
                  <span className="feature-tag feature-tag-meeting"><FaBriefcase /> Office Cabins</span>
                </div>
                <button type="button" className="card-select-btn card-select-btn-meeting">
                  Add Meeting Room
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyTypeModal;
